import { Injectable } from '@angular/core';

@Injectable() 
export class DataService {
  serviceData: object; 
}
